import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import NavigationDropdownDrawer from '../NavigationDropdownDrawer';

const HeaderNavDrawer = ({ surface, className, toggleClassName, ...rest }) => {
  return (
    <NavigationDropdownDrawer
      className={classNames(
        'HeaderNavDrawer',
        `HeaderNavDrawer--${surface}`,
        className
      )}
      toggleClassName={classNames(
        'HeaderNavDrawer__toggle',
        `HeaderNavDrawer__toggle--${surface}`,
        toggleClassName
      )}
      {...rest}
    />
  );
};

HeaderNavDrawer.propTypes = {
  surface: PropTypes.oneOf(['top', 'bottom']).isRequired,
  className: PropTypes.string,
  toggleClassName: PropTypes.string,
};

HeaderNavDrawer.defaultProps = {
  className: '',
  toggleClassName: '',
};

export default HeaderNavDrawer;
